import React, { useRef, useState } from 'react';

import { createOrganization } from '../../utils/api/organization_apis';
import { STATUS } from '../../utils/api/sharedfunction';
import { ORGANIZATION_COPY } from '../../constants/organizationCopy';
import ModalWrapper from '../ModalWrapper';
import { CommonFooter, FormSchemas, FormWrapper } from '../FormComponent';

const CreateOrganizationModal = ({ open, onClose, onSuccess, onError }) => {
  const [loading, setLoading] = useState(false);
  const formRef = useRef(null);

  const handleFormSubmit = async () => {
    if (formRef.current) {
      await formRef.current.submit();
    }
  };

  const handleCreateOrganization = async (data) => {
    try {
      setLoading(true);
      const { name, agentServiceUrl, mfaEnabled } = data;

      const response = await createOrganization({ 
        name, 
        agentServiceUrl: agentServiceUrl || null,
        mfaEnabled,
      });

      if (response.status === STATUS.SUCCESS) {
        onSuccess();
        onClose();
      } else {
        const error = { 
          response: { 
            data: { 
              message: response.error,
              errors: response.errors 
            } 
          } 
        };
        onError(error);
      }
    } catch (error) {
      console.error('Error creating organization:', error);
      onError(error);
    } finally {
      setLoading(false);
    }
  };

  const fields = [
    {
      name: 'name',
      type: 'text',
      label: 'Organization Name',
      placeholder: 'Enter organization name',
      required: true,
    },
    {
      name: 'agentServiceUrl',
      type: 'text',
      label: 'Agent Service URL',
      placeholder: 'Enter agent service URL',
      required: false,
    },
    {
      name: 'mfaEnabled',
      type: 'switch',
      label: ORGANIZATION_COPY.mfaEnabledLabel,
      required: false,
    },
  ];

  const buttons = [
    {
      label: 'Cancel',
      variant: 'outline',
      className: 'primary',
      onClick: onClose,
      disabled: loading,
      loading,
    },
    {
      label: 'Create',
      variant: 'primary',
      className: 'white bg-blue600',
      disabled: loading,
      loading,
      onClick: handleFormSubmit,
    },
  ];

  return (
    <ModalWrapper
      isOpen={open}
      onClose={onClose}
      title="Create New Organization"
      size="small"
      footer={
        <CommonFooter
          buttons={buttons}
          align="right"
        />
      }
      children={
        <FormWrapper
          ref={formRef}
          schema={FormSchemas.organizationForm}
          fields={fields}
          onSubmit={handleCreateOrganization}
          defaultValues={{
            name: '',
            agentServiceUrl: '',
            mfaEnabled: true,
          }}
        />
      }
    />
  );
};

export default CreateOrganizationModal; 